import { genComponentEl } from '@/utils/utils';
import SysState from './sysState';
import Setting from './setting.vue';

export function bc500SysStatus(data) {
  const content = genComponentEl(SysState, data);
  document.body.append(content);
}

export function bc500Setting(data) {
  const content = genComponentEl(Setting, data);
  document.body.append(content);
}
